import gql from 'graphql-tag'
import { CART_FRAGMENT } from './fragments.graphql'

export const EMPTY_CART = gql`
  ${CART_FRAGMENT}

  mutation EmptyCart($withRequiredEndUserInformation: Boolean = false) {
    emptyCart {
      ...Cart
    }
  }
`
